<template>
    <div style="display: none;"></div>
</template>
<script setup>
import { storeToRefs } from 'pinia';
import { useNotificationStore } from '@/stores/notification';
import Swal from 'sweetalert2';
import { watch } from 'vue';

const notify = useNotificationStore();
const { message, type, visible } = storeToRefs(notify);

watch(visible, (newVal) => {
    if (newVal) {
        Swal.fire({
            title: type.value === 'error' ? 'Error' : 'Notification',
            text: message.value,
            icon: type.value === 'error' ? 'error' : 'info',
            showCancelButton: !notify.retryCallback,
            confirmButtonText: notify.retryCallback ? 'Retry' : 'OK',
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            backdrop: ` rgba(0, 0, 0, 0.8) left top no-repeat`,
        }).then((result) => {
            if (result.isConfirmed && notify.retryCallback) {
                notify.retry();
            }
            notify.visible = false; // Hide notification after interaction
        });
    }
});
</script>
